var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMealPlanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 5.87258 5.37258 0.5 12 0.5H36C42.6274 0.5 48 5.87258 48 12.5V36.5C48 43.1274 42.6274 48.5 36 48.5H12C5.37258 48.5 0 43.1274 0 36.5V12.5Z",
    fill: "#FF627D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 16V14.5C20.75 14.09 20.41 13.75 20 13.75C19.59 13.75 19.25 14.09 19.25 14.5V16.06C19.5 16.03 19.73 16 20 16H20.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 16.06V14.5C28.75 14.09 28.41 13.75 28 13.75C27.59 13.75 27.25 14.09 27.25 14.5V16H28C28.27 16 28.5 16.03 28.75 16.06Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 16.06V17.5C28.75 17.91 28.41 18.25 28 18.25C27.59 18.25 27.25 17.91 27.25 17.5V16H20.75V17.5C20.75 17.91 20.41 18.25 20 18.25C19.59 18.25 19.25 17.91 19.25 17.5V16.06C16.3 16.33 15 18.23 15 21V29.5C15 32.5 16.5 34.5 20 34.5H28C31.5 34.5 33 32.5 33 29.5V21C33 18.23 31.7 16.33 28.75 16.06ZM24 29.25H20C19.59 29.25 19.25 28.91 19.25 28.5C19.25 28.09 19.59 27.75 20 27.75H24C24.41 27.75 24.75 28.09 24.75 28.5C24.75 28.91 24.41 29.25 24 29.25ZM28 24.25H20C19.59 24.25 19.25 23.91 19.25 23.5C19.25 23.09 19.59 22.75 20 22.75H28C28.41 22.75 28.75 23.09 28.75 23.5C28.75 23.91 28.41 24.25 28 24.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealPlanIcon);
export default __webpack_public_path__ + "static/media/meal-plan-icon.924bb4f5e9e323e2947829a2ff50a9f4.svg";
export { ForwardRef as ReactComponent };